export const longbeach_paths_october = ['sample-data'];

import {getLidarFileNames} from "../../getLidarFileNames";


export const arr_longbeach_paths_2026 = async (accessToken) =>  {
  try {
    const main_path = 'processed-lidar-data/portoflongbeach_ca_processed/';
    const raw_lidar_paths = await getLidarFileNames(main_path, accessToken)

    const lidar_paths = raw_lidar_paths.data.map(item => item.replace(main_path, '').replace('/', '')).filter(path => !path.includes('NAVVIS'));
  return lidar_paths.map((path) => { 
  return {
    url: `${process.env.REACT_APP_LIDAR_CDN_URL}/portoflongbeach_ca_processed/${path}`,
    name: `Longbeach CA - ${path}`,
    description: `Scan of Longbeach CA 2026 data`,
    date_uploaded: new Date('02/14/2026'),
   data_identifier: 'longbeach_ca',
  collector: 'portoflongbeach_collector',
  projection:  "+proj=lcc +lat_0=33.5 +lon_0=-118 +lat_1=35.4666666666667 +lat_2=34.0333333333333 +x_0=2000000.0001016 +y_0=500000.0001016 +datum=NAD83 +units=us-ft +no_defs +type=crs"
  }})
  } catch (error) {
    console.error('Error fetching Longbeach CA lidar paths:', error);
    return [];
  }
 
};